import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import './styles/styles.scss';
import './pages/common/vhelper/inputStyle.css';
import { ThemeContextProvider } from './contexts/themeContext';
import './i18n';
import App from './App/App';
import reportWebVitals from './reportWebVitals';
import UserContextProvider from './contexts/userContext';
import './pages/common/vhelper/scroll.css';
import { loadConfig } from './config';
import Errorpage from './pages/presentation/demo-pages/helper/Errorpage';
import { getClientSlugFromLocation } from './helpers/clientSlug';

if (process.env.NODE_ENV === 'production') {
	console.log = () => {};
	console.info = () => {};
	console.warn = () => {};
}

loadConfig()
	.then(() => {
		const slug = getClientSlugFromLocation(window.location);
		const basename = slug ? `/${slug}` : undefined;
		ReactDOM.render(
			<Router basename={basename}>
				<React.StrictMode>
					<ThemeContextProvider>
						<UserContextProvider>
							<App />
						</UserContextProvider>
					</ThemeContextProvider>
				</React.StrictMode>
			</Router>,
			document.getElementById('root'),
		);

		reportWebVitals();
	})
	.catch((error) => {
		console.error('Failed to load config.json:', error);
		ReactDOM.render(<Errorpage />, document.getElementById('root'));
	});
